import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { useOutsideClick } from '../../../Hooks/UseOutsideClick';
import BurgerMenuItem from './BurgerMenuItem';
import Icon from '@cb/solaris-react/Components/Content/Icon';
import { ShadowType, boxShadow } from '@cb/solaris-react/Constants/Shadows';
export default function BurgerMenu(props) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useOutsideClick(ref, () => setOpen(false));
    return (_jsxs(StyledBurgerMenu, { ref: ref, children: [_jsx(StyledBurgerIcon, { onClick: () => setOpen(true), children: _jsx(Icon, { name: "menu" }) }), open && (_jsx(StyledExpandedSection, { onClick: () => setOpen(false), children: props.items.map((item, index) => (_createElement(BurgerMenuItem, { ...item, key: index }))) }))] }));
}
export function getBurgerMenuHeight(theme) {
    return theme.sizing.md;
}
const StyledBurgerMenu = styled.div `
	position: relative;
	width: ${(props) => getBurgerMenuHeight(props.theme)};
	height: ${(props) => getBurgerMenuHeight(props.theme)};
	z-index: 3;
	// Fix properly and make only mobile responsive if we proceed with these nav changes
	display: none;

	@media (max-width: ${(props) => props.theme.breakpoints.sm}) {
		display: unset;
	}
`;
const StyledBurgerIcon = styled.button `
	width: 100%;
	height: 100%;
	padding: 0;
	margin: 0;
	color: ${(props) => props.theme.schemes.primary.text};
	background-color: ${(props) => props.theme.palette.primary};
	justify-content: center;
	align-items: center;
	border: none;
	flex-grow: 0;
	cursor: pointer;

	:hover,
	:focus {
		background-color: ${(props) => props.theme.schemes.primary.hover};
	}

	:active {
		background-color: ${(props) => props.theme.schemes.primary.active};
	}

	@media (max-width: ${(props) => props.theme.breakpoints.sm}) {
		background: none;
	}
`;
const StyledExpandedSection = styled.nav `
	position: absolute;
	top: ${(props) => getBurgerMenuHeight(props.theme)};
	left: 0;
	padding: ${(props) => props.theme.spacing.xs} 0px;
	background-color: ${(props) => props.theme.palette.shade7};
	${boxShadow(ShadowType.Subtle)}

	@media (max-width: ${(props) => props.theme.breakpoints.sm}) {
		width: 100vw;
	}
`;
//# sourceMappingURL=BurgerMenu.js.map